import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const adminDeclarationsReportsContract = c.router({
  exportAllDeclarations: {
    method: 'POST',
    path: '/declarations/export',
    body: z.object({
      batchId: z.string(),
      startDate: z.string(),
      endDate: z.string(),
      type: z.string(),
      allStatus: z.boolean(),
      declarationId: z.string(),
      status: z.string(),
    }),
    responses: {
      200: z.any(),
      400: z.object({ message: z.string() }),
      500: z.object({ message: z.string() }),
    },
  },
});
